module.exports = __webpack_public_path__ + "img/4092865.ae9576dc.gif";